import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Fetch_product_catalogue } from "../../hooks/APIHooks";

function CAT_MENU() {
  const [catalogueData, setCatalogueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [imageErrors, setImageErrors] = useState({});

  useEffect(() => {
    fetch(Fetch_product_catalogue)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setCatalogueData(data.data);
        } else {
          throw new Error(data.error || "An error occurred");
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const getImageUrl = (imagePath) => {
    if (!imagePath) {
      return '';
    }
    
    if (imagePath.startsWith('http')) return imagePath;
    
    const cleanPath = imagePath.replace(/^(\.?\/?)?/, '');
    
    // Handle different environments
    let baseUrl;
    const { hostname, port, protocol } = window.location;
    
    if (hostname === 'localhost' && port === '3000') {
      // React dev server on port 3000, APIs on port 80
      baseUrl = `${protocol}//${hostname}`;
    } else if (hostname === 'localhost' && !port) {
      // React build served from same domain as APIs
      baseUrl = window.location.origin;
    } else {
      // Production environment
      baseUrl = window.location.origin;
    }
    
    return `${baseUrl}/apis/${cleanPath}`;
  };

  const handleImageError = (catalogueId) => {
    setImageErrors(prev => ({
      ...prev,
      [catalogueId]: true
    }));
  };

  const handleImageLoad = (catalogueId) => {
    setImageErrors(prev => ({
      ...prev,
      [catalogueId]: false
    }));
  };

  return (
    <div className="relative">
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : error ? (
        <div className="text-center text-red-500 py-4">{error}</div>
      ) : (
        <div className="overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: "none" }}>
          <div className="flex w-full justify-between py-1 text-center sm:py-4 border-b">
            {catalogueData.map((item) => (
              <Link
                key={item.catalogue_id}
                to={`/Store/sub-catalogue/${item.catalogue_id}`}
                className="flex flex-col items-center w-1/5 px-2 min-w-[80px]"
              >
                <div className="w-14 h-14 sm:w-24 sm:h-24 flex items-center justify-center rounded-full overflow-hidden border border-gray-300 bg-gray-100">
                  {item.catalogue_image && !imageErrors[item.catalogue_id] ? (
                    <img
                      src={getImageUrl(item.catalogue_image)}
                      alt={item.catalogue_name}
                      className="w-full h-full object-cover"
                      onError={() => handleImageError(item.catalogue_id)}
                      onLoad={() => handleImageLoad(item.catalogue_id)}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                      <span className="text-gray-500 text-xs text-center px-1">
                        {item.catalogue_name.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                </div>
                <span className="mt-1 leading-[1] text-[10px] sm:text-sm font-medium text-center w-full break-words">
                  {item.catalogue_name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CAT_MENU;